import {SxProps, Theme} from '@mui/material';
import {Font} from '~/constants/style';

const baseFlexColumn: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
};

const baseFlexRow: SxProps<Theme> = {
  display: 'flex',
};

const baseGap1: SxProps<Theme> = {
  gap: 1,
};

const baseGap2: SxProps<Theme> = {
  gap: 2,
};

const baseTypography: SxProps<Theme> = {
  fontFamily: Font.Lexend,
  fontWeight: 400,
};

// Component styles
export const radioGroupStyles: SxProps<Theme> = {
  ...baseFlexRow,
  gap: '2rem',
};

export const alternatePaymentBoxStyles: SxProps<Theme> = {
  ...baseFlexRow,
  mt: 4,
  p: 2,
  borderRadius: 2,
  bgcolor: '#F6F6FF',
  border: '1px solid #e0e0e0',
  alignItems: 'flex-start',
  gap: 3,
};

export const alternatePaymentIconStyles: SxProps<Theme> = {
  ...baseFlexRow,
  width: 56,
  height: 56,
  alignItems: 'center',
  justifyContent: 'center',
};

export const phoneNumberStyles: SxProps<Theme> = {
  cursor: 'pointer',
  borderBottom: '1px solid',
  borderColor: 'primary.main',
};

export const responsibilityCheckboxStyles: SxProps<Theme> = {
  mt: 4,
};

export const highlightedTextStyles: SxProps<Theme> = {
  color: 'primary.main',
};

export const formBoxStyles: SxProps<Theme> = {
  ...baseFlexColumn,
  ...baseGap2,
  mt: 2,
};

export const questionBoxStyles: SxProps<Theme> = {
  ...baseFlexColumn,
  ...baseGap2,
};

export const insuranceDetailsBoxStyles: SxProps<Theme> = {
  ...baseFlexColumn,
  ...baseGap1,
};

export const selectInputBoxStyles: SxProps<Theme> = {
  ...baseFlexColumn,
  ...baseGap1,
  width: '35%',
};

export const inputContainerStyles: SxProps<Theme> = {
  ...baseFlexColumn,
  ...baseGap1,
  width: '50%',
  border: '1px solid red',
};

export const InsuranceDescription: SxProps<Theme> = {
  ...baseTypography,
  color: '#475467',
  fontSize: '16px',
  lineHeight: '22px',
  letterSpacing: '-0.75%',
};
